<div class="dashboard">
  <div *ngIf="authService.isUserAdmin()" class="admin-message">
    <p-card>
      <div class="text-center p-5">
        <i class="pi pi-shield text-6xl text-blue-500 mb-3"></i>

        <h2 class="text-2xl font-bold mb-2">
          {{ "i18n.domain.home.adminDashboard.title" | translate }}
        </h2>

        <p class="text-gray-600">
          {{ "i18n.domain.home.adminDashboard.message1" | translate }}
        </p>

        <p class="text-gray-600">
          {{ "i18n.domain.home.adminDashboard.message2" | translate }}
        </p>
      </div>
    </p-card>
  </div>

  <ng-container *ngIf="!authService.isUserAdmin()">
    <div class="stats-grid">
      <div class="stat-card">
        <p-card
          header="{{ 'i18n.domain.home.cards.pendingOrders' | translate }}"
          class="text-center shadow-2"
        >
          <div class="card-body-wrapper">
            <h2 class="text-4xl font-bold text-blue-600">
              {{ pendingOrdersCount }}
            </h2>

            <p class="text-gray-600">
              {{ "i18n.domain.home.cards.pendingOrders.subtitle" | translate }}
            </p>
          </div>
        </p-card>
      </div>

      <div class="stat-card">
        <p-card
          header="{{ 'i18n.domain.home.cards.totalOrders' | translate }}"
          class="text-center shadow-2"
        >
          <div class="card-body-wrapper">
            <h2 class="text-4xl font-bold text-green-600">
              {{ totalOrdersCount }}
            </h2>

            <p class="text-gray-600">
              {{ "i18n.domain.home.cards.totalOrders.subtitle" | translate }}
            </p>
          </div>
        </p-card>
      </div>

      <div class="stat-card">
        <p-card
          header="{{
            'i18n.domain.home.cards.totalConnections.title' | translate
          }}"
          class="text-center shadow-2"
        >
          <div class="card-body-wrapper">
            <h2 class="text-4xl font-bold text-purple-600">
              {{ totalTrustedConnections }}
            </h2>

            <p class="text-gray-600">
              {{
                "i18n.domain.home.cards.totalConnections.subtitle" | translate
              }}
            </p>
          </div>
        </p-card>
      </div>

      <div class="stat-card">
        <p-card
          header="{{
            'i18n.domain.home.cards.recentConnections.title' | translate
          }}"
          subheader="{{
            'i18n.domain.home.cards.recentConnections.subheader' | translate
          }}"
          class="text-center shadow-2"
        >
          <div class="card-body-wrapper">
            <h2 class="text-4xl font-bold text-orange-600">
              {{ newTrustedConnections }}
            </h2>

            <p class="text-gray-600">
              {{
                "i18n.domain.home.cards.recentConnections.subtitle" | translate
              }}
            </p>
          </div>
        </p-card>
      </div>
    </div>

    <div class="charts-grid">
      <div class="chart-container">
        <p-card
          header="{{
            'i18n.domain.home.charts.orderHistory.title' | translate
          }}"
        >
          <p-chart
            type="bar"
            [data]="chartData"
            [options]="chartOptions"
            width="100%"
          ></p-chart>
        </p-card>
      </div>

      <div class="map-container">
        <p-card>
          <p-header class="map-card-header-flex">
            <span class="map-title-text">
              {{ "i18n.domain.home.map.title" | translate }}
            </span>
            <div class="map-header-dropdown">
              <p-dropdown
                [options]="mapFilterOptions"
                [(ngModel)]="selectedMapFilter"
                optionLabel="label"
                optionValue="value"
                placeholder="Filter Orders"
                (onChange)="applyMapFilter()"
              ></p-dropdown>
            </div>
          </p-header>

          <div class="map-legend">
            <div class="legend-item">
              <span class="legend-marker recent"></span>
            </div>

            <div class="legend-item">
              <span class="legend-marker moderate"></span>
            </div>

            <div class="legend-item">
              <span class="legend-marker old"></span>
            </div>
          </div>

          <google-map
            [center]="mapCenter"
            [zoom]="mapZoom"
            height="100%"
            width="100%"
            [options]="{
              mapTypeControl: true,
              streetViewControl: false,
              fullscreenControl: true,
            }"
          >
            <map-marker
              *ngFor="let marker of markers"
              [position]="marker.position"
              [title]="marker.title"
              [label]="marker.label"
              [icon]="marker.icon"
            ></map-marker>
          </google-map>
        </p-card>
      </div>
    </div>
  </ng-container>
</div>
